import { render, staticRenderFns } from "./agendanovo-item.vue?vue&type=template&id=e35ee4e6&"
import script from "./agendanovo-item.vue?vue&type=script&lang=js&"
export * from "./agendanovo-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports